import { FIXED_INDENTS } from 'vars/index'

export const TextBlockRowGap = {
  INDENT_0: FIXED_INDENTS.INDENT_0,
  INDENT_10: FIXED_INDENTS.INDENT_10,
  INDENT_20: FIXED_INDENTS.INDENT_20,
  INDENT_30: FIXED_INDENTS.INDENT_30,
  INDENT_40: FIXED_INDENTS.INDENT_40,
  INDENT_50: FIXED_INDENTS.INDENT_50,
  INDENT_60: FIXED_INDENTS.INDENT_60,
  INDENT_70: FIXED_INDENTS.INDENT_70,
  INDENT_80: FIXED_INDENTS.INDENT_80,
} as const
export type TextBlockRowGap =
  (typeof TextBlockRowGap)[keyof typeof TextBlockRowGap]

export const TextBlockDirection = {
  COLUMN: 'column',
  ROW: 'row',
  INLINE: 'inline',
} as const
export type TextBlockDirection =
  (typeof TextBlockDirection)[keyof typeof TextBlockDirection]

export const ShowMorePositions = {
  Inline: 'inline',
  Under: 'under',
} as const
export type ShowMorePositions =
  (typeof ShowMorePositions)[keyof typeof ShowMorePositions]

export const TextBlockJustifyContent = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
} as const
export type TextBlockJustifyContent =
  (typeof TextBlockJustifyContent)[keyof typeof TextBlockJustifyContent]

export const TextBlockAlignItems = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
} as const
export type TextBlockAlignItems =
  (typeof TextBlockAlignItems)[keyof typeof TextBlockAlignItems]
